import { render, staticRenderFns } from "./weakTips.vue?vue&type=template&id=08f4fb6e&scoped=true"
import script from "./weakTips.vue?vue&type=script&lang=js"
export * from "./weakTips.vue?vue&type=script&lang=js"
import style0 from "./weakTips.vue?vue&type=style&index=0&id=08f4fb6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f4fb6e",
  null
  
)

export default component.exports